import { GET, POST } from "./";
const creditConversion = {
  getByProjectId: (projectId) =>
    GET(`/api/creditConversion/getbyprojectid/${projectId}`),
  downloadFile: (data) => POST(`/api/creditConversion/download-file`, data),
  save: (data) => POST(`/api/creditConversion/save`, data),
};
export default creditConversion;
